export default class WorkflowRunnerError extends Error {
    constructor(code, message, details = {}) {
        super(message)

        this.name = 'WorkflowRunnerError'
        this.code = code
        this.details = details
    }
}
